
/**
 * 保存业务回调方法
 */
window.KEWLPageEvent = {
  pageShowCalls: [],
  pageHideCalls: [],
  onPageShow(callback) {
    if (!(callback instanceof Function)) {
      throw new Error('Arguments must be function');
    }
    this.pageShowCalls.push(callback);
  },
  onPageHide(callback) {
    if (!(callback instanceof Function)) {
      throw new Error('Arguments must be function');
    }
    this.pageHideCalls.push(callback);
  }
};

window.pagedidappear = (...argu) => {
  window.KEWLPageEvent.pageShowCalls.forEach((callback) => {
    callback && callback(...argu);
  });
};

window.pagediddisappear = (...argu) => {
  window.KEWLPageEvent.pageHideCalls.forEach((callback) => {
    callback && callback(...argu);
  });
};
